<template>
  <v-app-bar app color="white" height="63" clipped-left dense class="dashboard-navbar px-3">
    <v-app-bar-nav-icon class="d-lg-none" @click.stop="setNavigationDrawer"></v-app-bar-nav-icon>
    <v-toolbar-title
      @click="redirectToDashboard"
      class="dashboard-navbar__logo-container"
      :class="{ 'ma-auto': xsOrsm }"
    >
      <GauravImpexLogo variant="small" />
    </v-toolbar-title>
    <v-spacer class="d-none d-md-block" />
    <div class="dashboard-navbar__select-container d-none d-md-block">
      <v-select
        v-model="timePeriod"
        single-line
        solo
        item-text="date"
        item-value="id"
        dense
        @change="updateTimePeriod"
        hide-details
        attach
        :menu-props="{ bottom: true, offsetY: true }"
        :items="timePeriods"
        label="Standard"
      ></v-select>
    </div>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="button-primary" class="pl-3" v-on="on" @click="addNewTimePeriod">
            fa fa-plus-circle
          </v-icon>
        </template>
        Add new Time Period
      </v-tooltip>
    </div>
    <v-divider vertical class="mx-3 d-none d-md-block"></v-divider>
    <div class="dashboard-navbar__menu-container d-none d-md-block">
      <v-menu bottom offset-y attach>
        <template v-slot:activator="{ on, attrs }">
          <!-- No Buttons -->
          <div v-on="on" v-bind="attrs" class="d-flex align-center justify-center">
            <v-icon small left>fas fa-user-alt</v-icon>
            <span>{{ userName }}</span>
            <v-icon right>fas fa-caret-down</v-icon>
          </div>
        </template>
        <v-list>
          <v-list-item @click="learnToUseDoc()">
            <v-list-item-title>Learn to use</v-list-item-title>
          </v-list-item>
          <v-list-item @click="icegateDigitalSign()">
            <v-list-item-title>Icegate Digital Sign</v-list-item-title>
          </v-list-item>
          <v-list-item @click="icegateLogin()">
            <v-list-item-title>Icegate Login</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$emit('logout')">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-icon>far fa-user</v-icon>
      <span class="ml-2">Gaurav Jiandani</span> -->
    </div>
  </v-app-bar>
</template>
<script>
import GauravImpexLogo from "@/components/GauravImpexLogo";
import * as AT from "@/modules/DashboardModule/store/actionTypes";
// import { GET_ESANCHIT_SUPPORTING_DOC } from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "DashboardTopNavbar",
  components: {
    GauravImpexLogo
  },

  mounted() {
    this.getUser();
    this.getTimePeriods();
    this.getGlobalTimePeriod();
  },
  created() {
    this.drawer = this.navigationDrawer;
  },
  data() {
    return {
      drawer: true,
      isTimePeriodLoading: false
    };
  },
  props: {
    appName: {
      default: "",
      type: String
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    setNavigationDrawer() {
      this.drawer = !this.drawer;
      this.$store.dispatch(AT.STORE_NAVIGATION_STATE, { drawer: this.drawer });
    },
    redirectToDashboard() {
      this.$router.push({ name: "dashboard.home" });
    },
    addNewTimePeriod() {
      if (this.$route.name != "dashboard.settings") {
        return this.$router.push({ name: "dashboard.settings" });
      }
      return;
    },
    icegateDigitalSign() {
      const url = "http://icegatesign.ncode.in:8080/ICEGATE/signTextFiles.jsp";
      var win = window.open(url, "_blank");
      win.focus();
    },
    icegateLogin() {
      const url = "https://www.icegate.gov.in/iceLogin/loginAction";
      var win = window.open(url, "_blank");
      win.focus();
    }
  },
  computed: {
    userName() {
      return this.$store.state.AuthModuleStore.user.name;
    }
  }
};
</script>
<style lang="scss">
i .dashboard-navbar {
  .v-btn:focus {
    &::before {
      opacity: 0;
      background: transparent;
    }
  }
  .v-btn:hover {
    &::before {
      opacity: 0;
      background: transparent;
    }
  }
  &__select-container {
    max-width: 22rem;
    .v-input.theme--light.v-text-field.v-text-field--enclosed.v-select {
      .v-input {
        &__slot {
          box-shadow: none !important;
        }
      }
    }
  }
  &__menu-container {
    .v-menu.v-menu--attached {
      .v-menu__content {
        top: 55px !important;
      }
    }
  }
}
</style>
